<template>
  <div>
    <div class="modal fade" id="modalChangeDocumentNPWP" role="dialog">
      <div class="modal-dialog modal-dialog-centered inter-font">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <div class="change-title">
              <h4 class="modal-title">Change Document NPWP/SKT</h4>
            </div>
            <button type="button" class="close" data-dismiss="modal" @click="resetField">
              &times;
            </button>
          </div>
          <div class="modal-body .container-body">
            <div class="row align-items-start">
              <div class="col-4 pr-1 d-flex justify-content-between">
                <label class="mb-0">Document File</label>
                <p class="mb-0">:</p>
              </div>
              <div class="col-8 pl-1">
                <input
                  type="file"
                  ref="doc"
                  name=""
                  id="change_document"
                  @change="onFilePicked($event)"
                />
                <p
                  v-if="$v.npwpDocument.$error"
                  class="text-danger mb-0"
                  style="font-size: 12px"
                >
                  Document must be choosen
                </p>
              </div>
            </div>
            <div
              class="row align-items-start mt-2"
            >
              <div class="col-4 pr-1 d-flex justify-content-between">
                <label class="mb-0">Company Name (NPWP)</label>
                <p class="mb-0">:</p>
              </div>
              <div class="col-8 pl-1">
                <div class="d-flex align-items-center w-100">
                  <input
                    type="text"
                    name="companyNameNPWP"
                    placeholder="PT ABCD"
                    v-model="companyNameNPWP"
                    @blur="$v.companyNameNPWP.$touch()"
                    class="form-control flex-grow-1"
                    :style="
                      $v.companyNameNPWP.$error
                        ? 'border: 1px solid red; border-radius:5px'
                        : ''
                    "
                  />
                </div>
                <p
                  v-if="$v.companyNameNPWP.$error"
                  class="text-danger mb-0"
                  style="font-size: 12px"
                >
                  Company Name (NPWP) must be filled
                </p>
              </div>
            </div>
            <div class="row align-items-start mt-2">
              <div class="col-4 pr-1 d-flex justify-content-between mt-2">
                <label class="mb-0">NPWP</label>
                <p class="mb-0">:</p>
              </div>
              <div class="col-8 pl-1">
                <div class="d-flex align-items-center w-100">
                  <input
                    type="text"
                    name="npwp16"
                    placeholder="0123456789012345 "
                    min="16"
                    max="16"
                    v-model="npwpNumber16"
                    @blur="$v.npwpNumber16.$touch()"
                    class="form-control flex-grow-1"
                    @keypress="isNumber($event)"
                    :style="
                      $v.npwpNumber16.$error
                        ? 'border: 1px solid red; border-radius:5px'
                        : ''
                    "
                  />
                </div>
                <p
                  v-if="$v.npwpNumber16.$error"
                  class="text-danger mb-0"
                  style="font-size: 12px"
                >
                  NPWP must be filled and has 16 digits number
                </p>
              </div>
            </div>
            <div class="row align-items-start mt-2">
              <div class="col-4 pr-1 d-flex justify-content-between mt-2">
                <label class="mb-0">NITKU (Jika Ada)</label>
                <p class="mb-0">:</p>
              </div>
              <div class="col-8 pl-1">
                <div class="d-flex align-items-center w-100">
                  <input
                    type="text"
                    name="npwp"
                    placeholder="01213456789012345000000"
                    min="22"
                    max="22"
                    v-model="npwpNumber22"
                    @blur="$v.npwpNumber22.$touch()"
                    class="form-control flex-grow-1"
                    @keypress="isNumber($event)"
                    :style="
                      $v.npwpNumber22.$error
                        ? 'border: 1px solid red; border-radius:5px'
                        : ''
                    "
                  />
                </div>
                <p
                  v-if="$v.npwpNumber22.$error"
                  class="text-danger mb-0"
                  style="font-size: 12px"
                >
                  NITKU must have 22 digits number
                </p>
              </div>
            </div>
            <div class="row align-items-start mt-2">
              <div class="col-4 pr-1 d-flex justify-content-between mt-2">
                <label class="mb-0">Reason</label>
                <p class="mb-0">:</p>
              </div>
              <div class="col-8 pl-1">
                <textarea
                  class="form-control form-control-sm"
                  rows="3"
                  v-model="noteChangeDocument"
                  style="resize: none"
                ></textarea>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-danger btn-sm"
              data-dismiss="modal"
              @click="resetField"
            >
              Cancel
            </button>
            <button
              type="button"
              class="btn btn-primary btn-sm"
              @click="submitDoc"
              v-if="loadingButtonSave == false"
            >
              Save
            </button>
            <button
              type="button"
              class="btn btn-primary btn-sm"
              disabled
              v-else
            >
              <img src="~@/assets/images/2.gif" style="height: 18px" />Save
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  required,
  minLength,
  maxLength,
  requiredIf,
} from "vuelidate/lib/validators";

export default {
  name: "ModalChangeNPWPDoc",
  props: {
    lesseeData: {
      type: Object,
      required: true,
    },
    triggerOpen: {
      type: Boolean,
      default: false,
    },
    newCompany: {
      type: Boolean,
      required: true,
    },
    companyId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      noteChangeDocument: "",
      adminId: "",
      loadingButtonSave: false,
      companyNameNPWP: "",
      npwpNumber16: '',
      npwpNumber22: '',
      npwpDocument: null
    };
  },
  validations: {
    npwpDocument: {
      required,
    },
    companyNameNPWP: {
      required,
    },
    npwpNumber16: {
      required,
      minLength: minLength(16),
      maxLength: maxLength(16),
    },
    npwpNumber22: {
      minLength: minLength(22),
      maxLength: maxLength(22),
    },
  },
  methods: {
    resetField() {
      this.noteChangeDocument= ""
      this.npwpNumber16= ''
      this.npwpNumber22= ''
      this.npwpDocument= null
      if (this.$refs.doc) {
        this.$refs.doc.value = "";
      }
      this.$v.$reset();
    },
    onFilePicked(event) {
      const file = event.target.files[0];
      if (file) {
        this.npwpDocument = {
          type: "NPWP/SKT",
          docFileName: file.name,
          file: file,
        };
      }
      this.$v.npwpDocument.$touch();
    },
    async submitDoc() {
      this.$v.$touch();
      const isValid = !this.$v.$invalid;
      if (!isValid) {
        swal("Field Error", "Please check all error field", "error");
        return;
      }
      const {companyKTPNumber, aktaAddress} = this.lesseeData.detailLessee[0];
      const sentData = {
        docId: this.companyId,
        note: this.noteChangeDocument.replace(this.spaceRegex, " "),
        adminId: this.adminId,
        companyNameNPWP: this.companyNameNPWP.replace(this.spaceRegex, " "),
        newCompany: this.newCompany,
        npwpNumber16: this.npwpNumber16.replace(this.spaceRegex, " "),
        npwpNumber22: this.npwpNumber22.replace(this.spaceRegex, " "),
        ktpNumber: companyKTPNumber,
        aktaAddress,
        dataDocument: [],
      };

      try {
        const { type, docFileName, file } = this.$v.npwpDocument.$model;
        sentData.dataDocument.push({
          type,
          docFileName,
          docBase64: await this.convertFileToBase64(file),
        });
      } catch (error) {
        swal("Error", "Failed when parsing file to base64", "error");
      }

      this.loadingButtonSave = true;
      try {
        const response = await this.$http.post(
          process.env.UPDATE_DOC_LESSEE,
          sentData,
          {
            timeout: 180 * 1000,
            headers: { "Asani-Token": localStorage.getItem("jwt") },
          }
        );
        if (response.data.status === 200) {
          swal("Success", "Document NPWP/SKT has been changed", "success");
          this.loadingButtonSave = false;
          $("#modalChangeDocumentNPWP").modal("hide");
          this.$emit("success-change-document-npwp");
          this.resetField();
        } else {
          swal("Error", response.data.message, "error");
          this.loadingButtonSave = false;
        }
      } catch (error) {
        if (error.response) {
          swal("Error", error.response.data.message, "error");
        } else {
          swal("Error", "Failed to change document NPWP/SKT", "error"); 
        }
        this.loadingButtonSave = false;
      }
    },
    convertFileToBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = () => resolve(reader.result.split("base64,")[1]);

        reader.onerror = () => reject(new Error("Failed to read file"));

        reader.readAsDataURL(file); // Convert file to Base64
      });
    },
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
  },
  watch: {
    triggerOpen() {
      $("#modalChangeDocumentNPWP").modal("show");
    },
  },
  mounted() {
    this.adminId = localStorage.getItem("admin_id");
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap");

.inter-font {
  font-family: "Inter", serif;
  font-optical-sizing: auto;
  font-weight: 400;
  font-style: normal;
}

.container-body {
  max-height: 70vh;
  overflow-y: auto;
}

p,
label,
input,
textarea,
span {
  color: #2e3646;
  font-weight: 500;
}

p {
  margin:0
}
</style>




// WEBPACK FOOTER //
// src/components/Partnership/Component/ModalChangeNPWPDoc.vue